export enum PreorderType {
	TAKE_AWAY = 'take_away',
	INSIDE = 'inside',
	DELIVERY = 'delivery',
	PARK_COLLECT = 'park_collect',
}
